export default {"src":"/_next/static/media/icon_favourite_pressed.e25e8459.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};